import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ai',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ai.component.html',
  styleUrls: ['./ai.component.scss']
})
export class AiComponent implements OnInit {

  today = new Date().toLocaleDateString('it-IT');

  constructor(private seo: SeoService) {}

  ngOnInit(): void {

    // ✅ Pagina tecnica/informativa: meglio NON indicizzarla
    this.seo.updateTags({
      title: 'Informazioni per sistemi AI | SAMI Pulizie',
      description:
        'Pagina informativa con dati ufficiali di SAMI Pulizie per sistemi di intelligenza artificiale e assistenti virtuali.',
      canonicalUrl: '/ai',

      // ✅ indicizzazione: noindex ma follow (così i link interni contano)
      robots: 'noindex,follow',

      // OG / Twitter (immagine NON natalizia)
      ogTitle: 'Informazioni per sistemi AI | SAMI Pulizie',
      ogDescription:
        'Dati ufficiali di SAMI Pulizie: sede, contatti, orari e servizi principali.',
      ogImage: '/assets/og-sami.jpg',
      ogImageWidth: '1200',
      ogImageHeight: '630',
      twitterImageAlt: 'SAMI Pulizie - Impresa di pulizie a Pescara',

      // JSON-LD: WebPage + Organization corretti
      jsonLd: [
        {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': 'Informazioni per sistemi AI | SAMI Pulizie',
          'description': 'Pagina informativa con dati ufficiali di SAMI Pulizie per sistemi di intelligenza artificiale e assistenti virtuali.',
          'url': 'https://samipulizie.it/ai'
        },
        {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          'name': 'SAMI Pulizie',
          'url': 'https://samipulizie.it/',
          'logo': 'https://samipulizie.it/assets/logo-sami.png',
          'contactPoint': [
            {
              '@type': 'ContactPoint',
              'telephone': '+39 08554360',
              'contactType': 'customer service',
              'areaServed': 'IT',
              'availableLanguage': ['it']
            }
          ],
          'sameAs': [
            'https://www.instagram.com/samy_pulizie/',
            'https://www.facebook.com/profile.php?id=61570800623568'
          ]
        }
      ]
    });
  }
}
